module.exports = __webpack_public_path__ + "mo/img/06_Motiongraphic.a8916305.png";